import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';

export const FiDocumentTemplateStatesResolvePageTitle = [
    PageTitleService,
    'template',
    FiDocumentTemplateStatesResolvePageTitleResolveFunc,
];

export function FiDocumentTemplateStatesResolvePageTitleResolveFunc(pageTitleService: PageTitleService, template) {
    return pageTitleService.setTitleByItem(template);
}
